import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import z from "zod";

import { RecordDetails as RecordDetailsContainer } from "@/components/record-details";
import type { ModuleType } from "@/types/zoho.types";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

const RecordDetailsParamsSchema = z.object({
    recordId: z.string(),
    moduleType: z.enum(["Leads", "Contacts"] as [ModuleType, ModuleType]),
});

export const Route = createFileRoute(APP_ROUTES_FULL.RECORD_DETAILS)({
    component: RecordDetails,
    staticData: {
        config: {
            breadcrumb: { title: "record_details", to: APP_ROUTES_TO.RECORD_DETAILS },
            title: "record_details",
        },
    },
    params: {
        parse: (rawParams) => {
            const result = RecordDetailsParamsSchema.safeParse(rawParams);

            if (!result.success) {
                throw redirect({
                    to: APP_ROUTES_TO.ROOT,
                    state: {
                        toast: {
                            type: "error",
                            message: "invalid_route_parameters",
                        },
                    },
                });
            }

            return result.data;
        },
        stringify: (params) => ({
            recordId: params.recordId,
            moduleType: params.moduleType,
        }),
    },
});

function RecordDetails() {
    const { t } = useTranslation();
    const { recordId, moduleType } = Route.useParams();

    if (!recordId || !moduleType) {
        return <div>{t("no_record_found")}</div>;
    }

    return <RecordDetailsContainer recordId={recordId} moduleType={moduleType} />;
}
